export const idolData = {
	"order":[

		"chiyo",
		"kana",
		"aqua",
		"izumi",
		"aika",
		"hua",
		"erity",
		"rui",
		"rei"

	],
    "order_loading":[

		"aika","hua","aqua","erity","izumi","kana","rui","chiyo","rei"
	],

    "aika": {

        "name":"Aika Mujika",
        "firstName": "Aika",
        "lastName": "Mujika",
        "slug": "aika",
        "va": "NekoHimeLotus",
    
        "description": 
            "A longtime fan of idols, Aika's always dreamed of becoming an idol herself. With an unforgettable voice, Aika's the cheerful leader and founder of Dream Flower Idols. A second year student and the childhood friend of Aqua, her dream is to inspire others to shoot for the stars and pursue what makes them happy!",
        "descriptionAuthor": "cal",
    
        "age": 16,
        "birthday": "August 14th",
        "flower": "Lotus",
        "quote": "Aika dream on~*",
        "color": "#FFC4E2",
        "accentColor": "#B2F1F6",
        "reverseGradient": false,
        "colorName": "Baby pink",
    
        "placeOfBirth":"Yokohama, Japan",
        "videoCrop": {
            "pixelOffset": -30,
            "index": -4
        },
        "logos":{
            "iconIndex": 0,
            "textLogoOffset": 0
        }
    },

    "aqua":{

        "name":"Aqua",
        "firstName": "[redacted]",
        "lastName": "[redacted]",
        "slug": "aqua",
        "va": "Lunarveil",
    
        "description": 
            "Looking for a place where she can feel a sense of belonging, Aqua's the last member of the group. As an exchange student at Kazuniwa Academy, hailing from California, her voice is as refreshing and energizing as the ocean's waves! As a third year student, she's the childhood friend of Aika.",
        "descriptionAuthor": "cal",
    
        "age": 18,
        "birthday": "March 21st",
        "flower": "Violet",
        "quote": "Let's dive right in!",
        "color": "#7A42E0",
        "accentColor": "#4C3E7E",
        "reverseGradient": false,
        "colorName": "Violet",
    
        "placeOfBirth":"Los Angeles, USA",
        "videoCrop": {
            "pixelOffset": 0,
            "index": -2
        },"logos":{
            "iconIndex": 1,
            "textLogoOffset": 0
        }

    
    
    
    },
    
    "chiyo":{

        "name":"Chiyo Arima",
        "firstName": "Chiyo",
        "lastName": "Arima",
        "slug": "chiyo",
        "va": "Raki Kazuki",
    
        "description": 
            "Brutally honest and witty, Chiyo's a first year student who's not afraid to speak her mind! With a voice that's as energizing as the first sip of a soft drink, she's the childhood friend of Izumi Yukimoto and feels as if they've found lifelong friends to make memories in the idol group!",
        "descriptionAuthor": "cal",
    
        "age": 15,
        "birthday": "October 3rd",
        "flower": "Gerbera Daisy",
        "quote": "Gaoooo!",
        "color": "#FF773F",
        "accentColor": "#FFCE6F",
        "reverseGradient": false,
        "colorName": "Orange",

        "placeOfBirth":"Tokyo, Japan",
        "videoCrop": {
            "pixelOffset": 0,
            "index": -6
        },"logos":{
            "iconIndex": 2,
            "textLogoOffset": 0
        }

    
    
    
    },

    "erity":{

	"name":"Erity Eguchi",
	"firstName": "Erity",
	"lastName": "Eguchi",
	"slug": "erity",
	"va": "Evava",

	"description": 
		"Open-minded and wanting to broaden her horizons, Erity's taking on her latest challenge yet: Joining an idol group! As a third year student with a passion for video games, a soft voice and a competitive nature, she secretly hopes that she'll be able to sing for one of her favorite games in the future.",
	"descriptionAuthor": "cal",

	"age": 17,
	"birthday": "September 3rd",
	"flower": "Morning Glory",
	"quote": "Game start!!",
	"color": "#5AA0F8",
	"accentColor": "#FC94C7",
	"reverseGradient": false,
	"colorName": "Blue",

	"placeOfBirth":"Nagoya, Japan",
        "videoCrop": {
            "pixelOffset": 0,
            "index": -7
        },"logos":{
            "iconIndex": 3,
            "textLogoOffset": 0
        }
},

    "hua":{

        "name":"Hua Chen",
        "firstName": "Hua",
        "lastName": "Chen",
        "slug": "hua",
        "va": "Meimei",
    
        "description": 
            "A second year student from China with a passion for fashion designing. With Aika being the first to coax her out of her shell, she's passionate in everything she sets her mind on— hiding behind all her shyness is a voice as delicate as the embroidery on the outfits she sews!",
        "descriptionAuthor": "cal",
    
        "age": 16,
        "birthday": "May 21st",
        "flower": "Lilac",
        "quote": "Fuwafuwa",
        "color": "#E7B9FF",
        "accentColor": "#D980EC",
        "reverseGradient": true,
        "colorName": "Lilac",
    
        "placeOfBirth":"Beijing, China",
        "videoCrop": {
            "pixelOffset": 0,
            "index": -5
        },"logos":{
            "iconIndex": 4,
            "textLogoOffset": 0
        }

    },

    "izumi":{

        "name":"Izumi Yukimoto",
        "firstName": "Izumi",
        "lastName": "Yukimoto",
        "slug": "izumi",
        "va": "Kei Cerise",
    
        "description": 
            "With a strikingly powerful voice, Izumi's easily mistaken to be cold and appears emotionless to her fellow first years. With her childhood friend, Chiyo, by her side, she joined the group to convey her true feelings. Words don't come easily for her and Chiyo wants nothing more than to show her warm-hearted nature through songs.",
        "descriptionAuthor": "cal",
    
        "age": 15,
        "birthday": "April 3rd",
        "flower": "Forget-me-not",
        "quote": "I'll melt your heart!",
        "color": "#6AEBF6",
        "accentColor": "#BDFFFD",
        "reverseGradient": false,
        "colorName": "Cyan",
    
    
        "placeOfBirth":"Tokyo, Japan",
        "videoCrop": {
            "pixelOffset": -30,
            "index": -3
        },"logos":{
            "iconIndex": 5,
            "textLogoOffset": 0
        }
    
    },

    "kana":{

        "name":"Kana Nakamura",
        "firstName": "Kana",
        "lastName": "Nakamura",
        "slug": "kana",
        "va": "roari",
    
        "description": 
            "An exceptionally kind first year at Kazuniwa Academy and the youngest of the group. Curious about the world, she's well-liked by her fellow members and peers for her bright voice and amiable nature! The complete opposite of her best friend, Rui Miake, she's slowly discovering what it means to have fun in the group.",
        "descriptionAuthor": "cal",
    
        "age": 15,
        "birthday": "November 2nd",
        "flower": "Green Chrysanthemum",
        "quote": "Kanbatte!",
        "color": "#B7DE67",
        "accentColor": "#E1F68D",
        "reverseGradient": false,
        "colorName": "Light green",
        "placeOfBirth":"Hokkaido, Japan",
        "videoCrop": {
            "pixelOffset": -10,
            "index": -1
        },"logos":{
            "iconIndex": 6,
            "textLogoOffset": 0
        }
    
    },

    "rei":{

        "name":"Rei Miake",
        "firstName": "Rei",
        "lastName": "Miake",
        "slug": "rei",
        "va": "Joyce ter Stege",
    
        "description": 
            "Rei may be a first year student, but she's incredibly self-assured and introspective. As the younger sister of Rui Miake, she willingly goes along with most of her new hobbies—While she doesn't like crowds that much, performing in the group has been her favorite activity so far!",
        "descriptionAuthor": "cal",
    
        "age": 15,
        "birthday": "June 13th",
        "flower": "Rose",
        "quote": "Don't worry, I'll protect you.",
        "color": "#FF436D",
        "accentColor": "#FE9F94",
        "reverseGradient": false,
        "colorName": "Red",
        "placeOfBirth":"Yokohama, Japan",
        "videoCrop": {
            "pixelOffset": -5,
            "index": -8
        },"logos":{
            "iconIndex": 7,
            "textLogoOffset": -16
        }

    },

    "rui":{

        "name":"Rui Miake",
        "firstName": "Rui",
        "lastName": "Miake",
        "slug": "rui",
        "va": "Z3N",
    
        "description": 
            "The older sister of Rei Miake who's often mistaken to be a first year student instead of a second year student with her antics. Rui's always on the lookout for something new to try out, more often than not pulling her sister, Rei, or her best friend, Kana, along with her to try new snacks…",
        "descriptionAuthor": "cal",
    
        "age": 16,
        "birthday": "April 17th",
        "flower": "Daffodil",
        "quote": "Smile as brightly as the sun!",
        "color": "#FFD957",
        "accentColor": "#FE9F94",
        "reverseGradient": false,
        "colorName": "Yellow",
    
        "placeOfBirth":"Yokohama, Japan",
        "videoCrop": {
            "pixelOffset": -10,
            "index": 0
        },"logos":{
            "iconIndex": 8,
            "textLogoOffset": -12
        }

    }

}

